import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  container: {
    minHeight: "100vh",
    width: "100vw",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.5),
    position: "absolute",
    top: 0,
    left: 0,
    background: "#fff",
    [theme.breakpoints.down("sm")]: {
      alignItems: "flex-start",
      paddingTop: theme.spacing(2),
      position: "relative",
    },
  },
  logotypeContainer: {
    backgroundColor: theme.palette.primary.main,
    width: "60%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      width: "50%",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  logotypeImage: {
    width: 120,
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      width: 90,
    },
  },
  logotypeText: {
    color: "white",
    fontWeight: 500,
    fontSize: 84,
    [theme.breakpoints.down("md")]: {
      fontSize: 48,
    },
  },
  formContainer: {
    width: "100%",
    maxWidth: 400,
    margin: "0 auto",
    height: "auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    background: "#fff",
    borderRadius: 12,
    boxShadow: "0 2px 12px rgba(0,0,0,0.07)",
    padding: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      maxWidth: "95vw",
      padding: theme.spacing(2),
      boxShadow: "none",
      borderRadius: 0,
    },
  },
  form: {
    width: "100%",
    maxWidth: 340,
    margin: "0 auto",
    [theme.breakpoints.down("xs")]: {
      maxWidth: "100vw",
    },
  },
  tab: {
    fontWeight: 400,
    fontSize: 18,
    minWidth: 90,
    [theme.breakpoints.down("xs")]: {
      fontSize: 15,
      minWidth: 70,
      padding: "6px 8px",
    },
    '&.Mui-selected': {
      color: theme.palette.primary.main,
      fontWeight: 700,
      borderBottom: `2px solid ${theme.palette.primary.main}`,
    },
  },
  greeting: {
    fontWeight: 500,
    textAlign: "center",
    marginTop: theme.spacing(4),
    fontSize: 22,
    [theme.breakpoints.down("xs")]: {
      fontSize: 18,
      marginTop: theme.spacing(2),
    },
  },
  subGreeting: {
    fontWeight: 500,
    textAlign: "center",
    marginTop: theme.spacing(2),
    fontSize: 20,
    [theme.breakpoints.down("xs")]: {
      fontSize: 16,
      marginTop: theme.spacing(1),
    },
  },
  googleButton: {
    marginTop: theme.spacing(6),
    boxShadow: theme.customShadows.widget,
    backgroundColor: "white",
    width: "100%",
    textTransform: "none",
  },
  googleButtonCreating: {
    marginTop: 0,
  },
  googleIcon: {
    width: 30,
    marginRight: theme.spacing(2),
  },
  creatingButtonContainer: {
    marginTop: theme.spacing(4),
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    '& > *': {
      minHeight: 48,
      fontSize: 17,
      [theme.breakpoints.down("xs")]: {
        fontSize: 15,
        minHeight: 44,
      },
    },
  },
  createAccountButton: {
    height: 46,
    textTransform: "none",
  },
  formDividerContainer: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    display: "flex",
    alignItems: "center",
  },
  formDividerWord: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  formDivider: {
    flexGrow: 1,
    height: 1,
    backgroundColor: theme.palette.text.hint + "40",
  },
  errorMessage: {
    textAlign: "center",
  },
  textFieldUnderline: {
    "&:before": {
      borderBottomColor: theme.palette.primary.light,
    },
    "&:after": {
      borderBottomColor: theme.palette.primary.main,
    },
    "&:hover:before": {
      borderBottomColor: `${theme.palette.primary.light} !important`,
    },
  },
  textField: {
    fontSize: 17,
    [theme.breakpoints.down("xs")]: {
      fontSize: 15,
    },
    borderBottomColor: theme.palette.background.light,
  },
  formButtons: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(2),
    '& > *': {
      minHeight: 44,
      fontSize: 16,
      [theme.breakpoints.down("xs")]: {
        fontSize: 15,
        minHeight: 40,
      },
    },
    alignItems: "center",
  },
  forgetButton: {
    textTransform: "none",
    fontWeight: 400,
  },
  loginLoader: {
    marginLeft: theme.spacing(4),
  },
  copyright: {
    marginTop: theme.spacing(4),
    whiteSpace: "nowrap",
    [theme.breakpoints.up("md")]: {
      position: "absolute",
      bottom: theme.spacing(2),
    },
  },
}));
